const SocialIcons = () => {
  const styles = {
    icon: {
      textDecoration: "none",
      fontSize: "22px",
      padding: "10px",
      transition: "0.2s ease-in",
    },
  };

  return (
    <div className="socialIcons" style={styles.socialIcons}>
      <a className="icon" style={styles.icon} href="https://github.com/Dani-op" target="_blank" rel="noreferrer">
        <i className="fa-brands fa-github" aria-hidden="true" title="GitHub Profile"></i>
      </a>
      <a className="icon" style={styles.icon} href="https://www.linkedin.com/in/dani-op" target="_blank" rel="noreferrer">
        <i className="fa-brands fa-linkedin" aria-hidden="true" title="LinkedIn Profile"></i>
      </a>
      <a className="icon" style={styles.icon} href="https://resume.dani-op.com" target="_blank" rel="noreferrer">
        <i className="fa-solid fa-file-lines" aria-hidden="true" title="Resume Link"></i>
      </a>
    </div>
  );
};

export default SocialIcons;
